import { CurrentOrder } from "../current/CurrentOrder";
import { HistoryOrderList } from "../history/HistoryOrderList";
import { useOrderHandler } from "./useOrderHandler";

interface IParams {
    isHomePage?: boolean;
}

export const OrderHandler = (props: IParams) => {
    const { isHomePage = false } = props;
    const {
        cancelOrder,
        getHistoryOrderList,
        historyOrderList,
        historyOrderListState,
        selectedMonth,
        setSelectedMonth,
    } = useOrderHandler({ isHomePage });

    return (
        <>
            {!isHomePage && <CurrentOrder cancelOrder={cancelOrder} isHomePage={isHomePage} />}
            {!isHomePage && (
                <HistoryOrderList
                    getHistoryOrderList={getHistoryOrderList}
                    historyOrderList={historyOrderList}
                    historyOrderListState={historyOrderListState}
                    selectedMonth={selectedMonth}
                    setSelectedMonth={setSelectedMonth}
                />
            )}
        </>
    );
};
